// load jquery and foundation in the window scope

import 'core-js/stable';
import 'whatwg-fetch';
import 'initializers';
import '@stylesheets/index.scss';

document.addEventListener('DOMContentLoaded', function () {
  setTimeout(MaterialDesignForm, 0)
  toggleSidebar()

  window.slugify = slugify
});

const MaterialDesignForm = () => {
  document.querySelectorAll('.form--static .form__input').forEach((item) => {
    const formControl = getClosest(item, '.form__control');

    if (formControl && item.getAttribute('value')) {
      formControl.classList.add('form__control--not-empty');
    }

    const onChange = (e) => {
      if (e.target.value) {
        formControl.classList.add('form__control--not-empty');
      } else {
        formControl.classList.remove('form__control--not-empty');
      }
    }

    if (formControl) {
      item.addEventListener('focus', (e) => {
        formControl.classList.add('form__control--focus');
      });
      item.addEventListener('blur', (e) => {
        formControl.classList.remove('form__control--focus');
        onChange(e)
      });
      item.addEventListener('change', onChange)
      item.addEventListener('input', onChange)
    }
  });
}

const getClosest = function (elem, selector) {

  // Element.matches() polyfill
  if (!Element.prototype.matches) {
    Element.prototype.matches =
      Element.prototype.matchesSelector ||
      Element.prototype.mozMatchesSelector ||
      Element.prototype.msMatchesSelector ||
      Element.prototype.oMatchesSelector ||
      Element.prototype.webkitMatchesSelector ||
      function (s) {
        var matches = (this.document || this.ownerDocument).querySelectorAll(s),
          i = matches.length;
        while (--i >= 0 && matches.item(i) !== this) { }
        return i > -1;
      };
  }

  // Get the closest matching element
  for (; elem && elem !== document; elem = elem.parentNode) {
    if (elem.matches(selector)) return elem;
  }
  return null;

};


const slugify = (str) => {
  str = str.replace(/^\s+|\s+$/g, '');

  // Make the string lowercase
  str = str.toLowerCase();

  // Remove accents, swap ñ for n, etc
  const from = "ÁÄÂÀÃÅČÇĆĎÉĚËÈÊẼĔȆÍÌÎÏŇÑÓÖÒÔÕØŘŔŠŤÚŮÜÙÛÝŸŽáäâàãåčçćďéěëèêẽĕȇíìîïňñóöòôõøðřŕšťúůüùûýÿžþÞĐđßÆa·/_,:;";
  const to = "AAAAAACCCDEEEEEEEEIIIINNOOOOOORRSTUUUUUYYZaaaaaacccdeeeeeeeeiiiinnooooooorrstuuuuuyyzbBDdBAa------";

  for (var i = 0, l = from.length; i < l; i++) {
    str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
  }

  // Remove invalid chars
  str = str.replace(/[^a-z0-9 -]/g, '')
    // Collapse whitespace and replace by -
    .replace(/\s+/g, '-')
    // Collapse dashes
    .replace(/-+/g, '-');

  return str;
}

const toggleSidebar = () => {
  const PAGE_CLASSNAME = 'page--show-sidebar';
  const SIDEBAR_STATE_NAME = 'sidebar-state';

  const $page = document.querySelector('.page');
  const $sidebar = document.querySelector('.page__sidebar');

  if (!$page || !$sidebar) {
    return;
  }

  const $toggleButton = $sidebar.querySelector('.sidebar__toggle-button');
  const setState = (state) => {
    if (state) {
      $page.classList.add(PAGE_CLASSNAME);
    } else {
      $page.classList.remove(PAGE_CLASSNAME);
    }

    window.localStorage.setItem(SIDEBAR_STATE_NAME, state);
  }

  if ($toggleButton) {
    $toggleButton.addEventListener('click', () => {
      const state = window.localStorage.getItem(SIDEBAR_STATE_NAME) === 'true';
      setState(!state);
    });
  }

  const localStorateState = window.localStorage.getItem(SIDEBAR_STATE_NAME)
  let initialState = localStorateState === 'true';

  if (localStorateState === null) {
    initialState = $page.classList.contains(PAGE_CLASSNAME)
  }

  setState(initialState);
}
